// extracted by css-extract-rspack-plugin
export default {"group":"group-MRxkcQ","legend":"legend-j8Gocy","sources":"sources-fMFCE9","summary":"summary-CqKXGh"};